import React, {Component} from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DocumentsCollectUI from './DocumentsCollectUI'

class DocumentsCollectSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      account: null
    }
  }

  render() {
    return (
      <DocumentsCollectUI
        context={this.props.context}
        errorList={this.state.errorList}
        account={this.state.account}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccount(context)
  }

  getAccount = (context) => {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}`,
      cacheKey: CacheKeys.Account(context.session.accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({account: response.account})
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Account(context.session.accountId))
    this.setState({account: null}, this.getAccount(context))
  }
}

export default DocumentsCollectSF
